import React from "react";
import ReactSelect from "react-select";
import styled, { keyframes } from "styled-components";
import { device } from "../../../atoms/Utlis/media";

export const gradient = "linear-gradient(144.01deg, rgba(255, 201, 81, 0.8) 0%, rgba(206, 86, 176, 0.8) 100%)";

const slideIn = keyframes`
  from { opacity: 0; transform: translateY(-8px); }
  to { opacity: 1; transform: translateY(0); }
`;

const actionTooltipStyles = `
  position: relative;

  &::after {
    content: attr(data-tooltip);
    position: absolute;
    bottom: calc(100% + 8px);
    left: 50%;
    transform: translateX(-50%);
    padding: 5px 10px;
    border-radius: 8px;
    background: #171717;
    color: #ffffff;
    font-family: Montserrat, sans-serif;
    font-size: 11px;
    font-weight: 600;
    line-height: 1.2;
    white-space: nowrap;
    opacity: 0;
    visibility: hidden;
    pointer-events: none;
    transition: opacity 0.15s ease, visibility 0.15s ease;
    z-index: 20;
    box-shadow: 0 4px 12px rgba(23, 23, 23, 0.18);
  }

  &:hover::after {
    opacity: 1;
    visibility: visible;
  }
`;

export const ManageCategoriesBtn = styled.button`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 46px;
  padding: 0 18px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  border-radius: 12px;
  background: rgba(255, 255, 255, 0.9);
  color: rgba(23, 23, 23, 0.72);
  font-family: Urbanist, sans-serif;
  font-size: 14px;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.15s ease;
  &:hover {
    border-color: rgba(201, 77, 170, 0.25);
    color: #c94daa;
    transform: translateY(-1px);
    box-shadow: 0 6px 16px rgba(0, 0, 0, 0.06);
  }
`;

export const AlertStripeContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: 100%;
`;

export const AlertStripe = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 14px 18px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 201, 81, 0.12) 0%, rgba(240, 154, 62, 0.08) 100%);
  border: 1px solid rgba(240, 154, 62, 0.22);
  color: #b45309;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  box-shadow: 0 4px 14px rgba(240, 154, 62, 0.08);
  animation: ${slideIn} 0.28s ease;
`;

export const AlertContent = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
  flex: 1;
  line-height: 1.5;
`;

export const DismissBtn = styled.button`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: rgba(255, 255, 255, 0.7);
  border: 1px solid rgba(240, 154, 62, 0.2);
  color: #b45309;
  cursor: pointer;
  padding: 0;
  border-radius: 10px;
  flex-shrink: 0;
  transition: all 0.15s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.95);
    border-color: rgba(240, 154, 62, 0.35);
  }
`;

export const PageContainer = styled.div`
  width: 100%;
  padding: 24px;
  font-family: Urbanist, sans-serif;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-shrink: 0;
  box-sizing: border-box;
  @media ${device.tablet} { padding: 16px; }
`;

export const Hero = styled.div`
  position: relative;
  overflow: visible;
  flex-shrink: 0;
  border-radius: 20px;
  padding: 24px 26px;
  background: linear-gradient(
    135deg,
    rgba(255, 201, 81, 0.16) 0%,
    rgba(206, 86, 176, 0.12) 55%,
    rgba(53, 183, 200, 0.08) 100%
  );
  border: 1px solid rgba(201, 77, 170, 0.12);
  box-shadow: 0 8px 28px rgba(201, 77, 170, 0.08);
`;

export const HeroGlow = styled.div`
  pointer-events: none;
  position: absolute;
  top: -80px;
  right: -4%;
  width: 240px;
  height: 240px;
  border-radius: 50%;
  background: radial-gradient(circle, rgba(255, 201, 81, 0.32) 0%, transparent 70%);
`;

export const HeroContent = styled.div`
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  flex-wrap: wrap;
`;

export const HeroText = styled.div`
  min-width: 0;
`;

export const HeroBadge = styled.span`
  display: inline-flex;
  width: fit-content;
  align-items: center;
  gap: 6px;
  margin-bottom: 4px;
  padding: 5px 11px;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.78);
  border: 1px solid rgba(201, 77, 170, 0.14);
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: #c94daa;
`;

export const PageTitle = styled.h1`
  margin: 0;
  font-size: 28px;
  font-weight: 800;
  line-height: 1.25;
  padding: 2px 0;
`;

export const PageSubtitle = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.62);
  max-width: 560px;
`;

export const HeaderActions = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
  flex-shrink: 0;
  align-items: center;
`;

export const Panel = styled.div`
  width: 100%;
  background: #ffffff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  border-radius: 20px;
  box-shadow: 0 10px 32px rgba(23, 23, 23, 0.06);
  overflow: hidden;
  flex-shrink: 0;
  display: flex;
  flex-direction: column;
`;

export const PanelTop = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 20px 22px 0;
  flex-wrap: wrap;

  @media ${device.tablet} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const PanelTopRight = styled.div`
  display: flex;
  align-items: center;
  gap: 14px;
  flex-shrink: 0;
  flex-wrap: wrap;
`;

export const TableSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 20px 22px 0;
  min-height: 0;
`;

export const Divider = styled.div`
  height: 1px;
  background: rgba(23, 23, 23, 0.06);
  margin: 16px 0px 0;
`;

export const Toolbar = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 16px;
  padding: 16px 22px;
  @media ${device.tablet} { flex-direction: column; align-items: stretch; }
`;

export const SearchControl = styled.label`
  width: min(100%, 320px);
  min-width: 375px;
  height: 46px;
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 0 16px;
  border: 1px solid rgba(23, 23, 23, 0.1);
  border-radius: 12px;
  color: rgba(23, 23, 23, 0.42);
  background: #fafafa;
  transition: border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease;
  &:focus-within {
    background: #fff;
    border-color: rgba(201, 77, 170, 0.35);
    box-shadow: 0 0 0 3px rgba(201, 77, 170, 0.1);
  }
  input {
    width: 100%;
    border: none;
    outline: none;
    background: transparent;
    font-family: Urbanist, sans-serif;
    font-size: 14px;
    font-weight: 600;
    color: #171717;
    &::placeholder {
      color: rgba(23, 23, 23, 0.35);
      font-weight: 500;
    }
  }
`;

export const FiltersSelectRow = styled.div`
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
`;

const equipmentSelectStyles = {
  control: (base: any, state: any) => ({
    ...base,
    minHeight: "46px",
    minWidth: "140px",
    borderRadius: "12px",
    borderColor: state.isFocused ? "rgba(201, 77, 170, 0.4)" : "rgba(23, 23, 23, 0.1)",
    background: state.isFocused ? "#ffffff" : "#fafafa",
    boxShadow: state.isFocused ? "0 0 0 3px rgba(201, 77, 170, 0.1)" : "none",
    color: "rgba(23, 23, 23, 0.78)",
    fontFamily: "Urbanist, sans-serif",
    fontSize: "14px",
    fontWeight: 600,
    cursor: "pointer",
    transition: "border-color 0.15s ease, box-shadow 0.15s ease, background 0.15s ease",
    "&:hover": {
      borderColor: "rgba(201, 77, 170, 0.35)",
      background: "#ffffff",
    },
  }),
  valueContainer: (base: any) => ({
    ...base,
    padding: "0 14px",
  }),
  placeholder: (base: any) => ({
    ...base,
    color: "rgba(23, 23, 23, 0.45)",
    fontWeight: 500,
  }),
  input: (base: any) => ({
    ...base,
    margin: 0,
    padding: 0,
  }),
  singleValue: (base: any) => ({
    ...base,
    color: "rgba(23, 23, 23, 0.78)",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  dropdownIndicator: (base: any, state: any) => ({
    ...base,
    color: state.isFocused ? "#c94daa" : "rgba(23, 23, 23, 0.45)",
    padding: "0 12px 0 8px",
    transition: "transform 0.15s ease, color 0.15s ease",
    transform: state.selectProps.menuIsOpen ? "rotate(180deg)" : "rotate(0deg)",
  }),
  menu: (base: any) => ({
    ...base,
    marginTop: "8px",
    borderRadius: "16px",
    padding: "6px",
    border: "1px solid rgba(201, 77, 170, 0.12)",
    boxShadow: "0 18px 36px rgba(23, 23, 23, 0.14)",
    overflow: "hidden",
    zIndex: 9999,
  }),
  menuList: (base: any) => ({
    ...base,
    padding: 0,
  }),
  menuPortal: (base: any) => ({
    ...base,
    zIndex: 9999,
  }),
  option: (base: any, state: any) => ({
    ...base,
    borderRadius: "12px",
    padding: "11px 13px",
    fontFamily: "Urbanist, sans-serif",
    fontSize: "14px",
    fontWeight: state.isSelected ? 700 : 600,
    color: "#171717",
    background: state.isSelected
      ? "linear-gradient(135deg, rgba(255, 201, 81, 0.18), rgba(201, 77, 170, 0.16))"
      : state.isFocused
        ? "rgba(201, 77, 170, 0.08)"
        : "#ffffff",
  }),
};

type SelectProps = {
  id?: string;
  name?: string;
  value: string | number;
  onChange: (e: { target: { value: string } }) => void;
  children: React.ReactNode;
  disabled?: boolean;
};

export const Select: React.FC<SelectProps> = ({ id, name, value, onChange, children, disabled }) => {
  const options: Array<{ value: string; label: React.ReactNode; isDisabled?: boolean }> = [];

  React.Children.forEach(children, (child) => {
    if (React.isValidElement<any>(child) && child.type === "option") {
      options.push({
        value: String(child.props.value),
        label: child.props.children,
        isDisabled: child.props.disabled,
      });
    } else if (Array.isArray(child)) {
      child.forEach((nestedChild) => {
        if (React.isValidElement<any>(nestedChild) && nestedChild.type === "option") {
          options.push({
            value: String(nestedChild.props.value),
            label: nestedChild.props.children,
            isDisabled: nestedChild.props.disabled,
          });
        }
      });
    }
  });

  const selectedOption = options.find((option) => option.value === String(value)) ?? null;
  const placeholderOption = options.find((option) => option.isDisabled) ?? options.find((option) => option.value === "");

  return React.createElement(ReactSelect, {
    inputId: id,
    name,
    value: selectedOption,
    onChange: (option: any) => onChange({ target: { value: option?.value ?? "" } }),
    options: options.filter((option) => !option.isDisabled),
    placeholder: placeholderOption ? String(placeholderOption.label) : "Select an option",
    styles: equipmentSelectStyles,
    menuPosition: "fixed",
    menuPortalTarget: document.body,
    isSearchable: false,
    isDisabled: disabled,
  });
};

type EntriesSelectProps = {
  value: string | number;
  onChange: (e: { target: { value: string } }) => void;
  children: React.ReactNode;
};

export const EntriesSelect: React.FC<EntriesSelectProps> = ({ value, onChange, children }) => {
  const options: Array<{ value: string; label: React.ReactNode }> = [];

  React.Children.forEach(children, (child) => {
    if (React.isValidElement<any>(child) && child.type === "option") {
      options.push({
        value: String(child.props.value),
        label: child.props.children,
      });
    } else if (Array.isArray(child)) {
      child.forEach((nestedChild) => {
        if (React.isValidElement<any>(nestedChild) && nestedChild.type === "option") {
          options.push({
            value: String(nestedChild.props.value),
            label: nestedChild.props.children,
          });
        }
      });
    }
  });

  const selectedOption = options.find((option) => option.value === String(value)) ?? null;

  return React.createElement(ReactSelect, {
    value: selectedOption,
    onChange: (option: any) => onChange({ target: { value: option?.value ?? "" } }),
    options,
    styles: {
      ...equipmentSelectStyles,
      control: (base: any, state: any) => ({
        ...equipmentSelectStyles.control(base, state),
        minHeight: "38px",
        minWidth: "74px",
      }),
      valueContainer: (base: any) => ({
        ...base,
        padding: "0 10px",
      }),
      dropdownIndicator: (base: any, state: any) => ({
        ...equipmentSelectStyles.dropdownIndicator(base, state),
        padding: "0 10px 0 4px",
      }),
      option: (base: any, state: any) => ({
        ...equipmentSelectStyles.option(base, state),
        fontSize: "13px",
        padding: "10px 12px",
      }),
    },
    menuPosition: "fixed",
    menuPortalTarget: document.body,
    isSearchable: false,
  });
};

export const StatsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 12px;
  flex-shrink: 0;
  @media ${device.laptop} {
    grid-template-columns: repeat(2, 1fr);
  }
  @media (max-width: 600px) {
    grid-template-columns: 1fr;
  }
`;

export const WalletHero = styled.div`
  position: relative;
  overflow: hidden;
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  color: #fff;
  background: ${gradient};
  box-shadow: 0 8px 22px rgba(201, 77, 170, 0.22);
  text-align: left;

  &::after {
    content: "";
    position: absolute;
    right: -20px;
    bottom: -24px;
    width: 90px;
    height: 90px;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.12);
  }
`;

export const WalletIconWrap = styled.div`
  position: relative;
  z-index: 1;
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(255, 255, 255, 0.22);
`;

export const WalletHeroBody = styled.div`
  position: relative;
  z-index: 1;
  min-width: 0;
`;

export const WalletHeroValue = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: #fff;
  line-height: 1.1;
`;

export const WalletHeroLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
  margin-top: 2px;
`;

export const StatCard = styled.div<{ $tone: string }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 16px;
  border-radius: 16px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.06);
  box-shadow: 0 6px 18px rgba(23, 23, 23, 0.04);
`;

export const StatIcon = styled.div<{ $tone: string }>`
  width: 36px;
  height: 36px;
  border-radius: 11px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  color: ${(p) => p.$tone};
  background: ${(p) => `${p.$tone}18`};
`;

export const StatBody = styled.div`
  min-width: 0;
`;

export const StatValue = styled.div`
  font-family: Urbanist, sans-serif;
  font-size: 20px;
  font-weight: 800;
  color: #171717;
  line-height: 1.1;
`;

export const StatLabel = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.5);
  margin-top: 2px;
`;

/** @deprecated use StatValue */
export const StatNumber = StatValue;

/** @deprecated use StatIcon */
export const StatIconWrapper = StatIcon;

export const AlertBanner = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 14px;
  padding: 16px 18px;
  border-radius: 16px;
  background: linear-gradient(135deg, rgba(228, 72, 98, 0.08) 0%, rgba(228, 72, 98, 0.03) 100%);
  border: 1px solid rgba(228, 72, 98, 0.18);
  flex-shrink: 0;
`;

export const AlertIconWrap = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  background: rgba(228, 72, 98, 0.1);
  color: #e44862;
`;

export const AlertTitle = styled.div`
  font-family: Montserrat, sans-serif;
  font-weight: 800;
  color: #e44862;
  font-size: 14px;
  margin-bottom: 4px;
`;

export const AlertDesc = styled.div`
  font-family: Montserrat, sans-serif;
  color: rgba(23, 23, 23, 0.72);
  font-size: 13px;
  line-height: 1.55;
`;

export const EquipmentInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
  min-width: 0;
`;

export const EquipmentName = styled.span`
  font-family: Urbanist, sans-serif;
  font-weight: 700;
  color: #171717;
  font-size: 14px;
`;

export const EquipmentMeta = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: rgba(23, 23, 23, 0.5);
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`;

export const CategoryTag = styled.span`
  display: inline-flex;
  align-items: center;
  background: rgba(201, 77, 170, 0.1);
  color: #c94daa;
  padding: 2px 8px;
  border-radius: 999px;
  font-size: 10px;
  font-weight: 700;
`;

export const CodeText = styled.code`
  font-family: "Courier New", monospace;
  background: rgba(255, 201, 81, 0.12);
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  color: #b45309;
  font-weight: 700;
  border: 1px solid rgba(255, 201, 81, 0.2);
`;

const statusColors: Record<string, { bg: string; color: string }> = {
  Available: { bg: "rgba(49, 166, 106, 0.12)", color: "#31a66a" },
  Assigned: { bg: "rgba(53, 183, 200, 0.12)", color: "#35b7c8" },
  "Under Service": { bg: "rgba(255, 145, 0, 0.15)", color: "#ff9100" },
  Sold: { bg: "rgba(23, 23, 23, 0.08)", color: "rgba(23, 23, 23, 0.65)" },
  Retired: { bg: "rgba(228, 72, 98, 0.12)", color: "#e44862" },
};

export const StatusBadge = styled.span<{ $status: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 4px 10px;
  border-radius: 999px;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  white-space: nowrap;
  background: ${(p) => statusColors[p.$status]?.bg ?? "rgba(23,23,23,0.08)"};
  color: ${(p) => statusColors[p.$status]?.color ?? "#171717"};
`;

export const AssignedName = styled.div`
  font-family: Urbanist, sans-serif;
  font-weight: 700;
  color: #c94daa;
  font-size: 13px;
`;

export const ExpectedReturn = styled.div`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  color: #e44862;
  font-weight: 600;
  margin-top: 2px;
`;

export const EmptyDash = styled.span`
  color: rgba(23, 23, 23, 0.35);
  font-weight: 500;
`;

export const WarningIconsWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 6px;
`;

export const WarningTag = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  padding: 3px 8px;
  border-radius: 999px;
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  color: ${(p) => p.$color};
  background: ${(p) => `${p.$color}14`};
  border: 1px solid ${(p) => `${p.$color}28`};
`;

export const ActionsCell = styled.div`
  display: flex;
  justify-content: flex-end;
  gap: 6px;
`;

export const IconButton = styled.button<{ $danger?: boolean }>`
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid ${(p) => (p.$danger ? "rgba(228, 72, 98, 0.22)" : "rgba(201, 77, 170, 0.18)")};
  color: ${(p) => (p.$danger ? "#e44862" : "#c94daa")};
  background: ${(p) => (p.$danger ? "rgba(228, 72, 98, 0.06)" : "rgba(201, 77, 170, 0.06)")};
  cursor: pointer;
  flex: 0 0 auto;
  transition: all 0.15s ease;
  ${actionTooltipStyles}

  &:hover:not(:disabled) {
    background: ${(p) => (p.$danger ? "rgba(228, 72, 98, 0.12)" : "rgba(201, 77, 170, 0.12)")};
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.35;
    cursor: not-allowed;
    background: rgba(23, 23, 23, 0.04);
    border-color: rgba(23, 23, 23, 0.08);
    color: rgba(23, 23, 23, 0.3);
  }
`;

export const EntriesControl = styled.label`
  display: inline-flex;
  align-items: center;
  gap: 8px;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.62);
  select {
    height: 38px;
    border: 1px solid rgba(23, 23, 23, 0.1);
    border-radius: 10px;
    padding: 0 12px;
    background: #fafafa;
    color: #171717;
    font-family: Urbanist, sans-serif;
    font-size: 13px;
    font-weight: 600;
    outline: none;
    cursor: pointer;
    transition: border-color 0.15s ease;
    &:focus {
      border-color: rgba(201, 77, 170, 0.35);
    }
  }
`;

export const FooterRow = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
  padding: 18px 22px 22px;
  flex-shrink: 0;
  @media ${device.tablet} { flex-direction: column; align-items: flex-start; }
`;

export const FooterText = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 13px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.55);
`;

export const Pagination = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
`;

export const PageButton = styled.button<{ $active?: boolean }>`
  min-width: 36px;
  height: 36px;
  border: 1px solid ${(p) => (p.$active ? "transparent" : "rgba(23, 23, 23, 0.1)")};
  border-radius: 10px;
  padding: 0 12px;
  background: ${(p) => (p.$active ? gradient : "#fff")};
  color: ${(p) => (p.$active ? "#fff" : "rgba(23,23,23,0.65)")};
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
  cursor: pointer;
  transition: all 0.15s ease;
  box-shadow: ${(p) => (p.$active ? "0 4px 12px rgba(201, 77, 170, 0.22)" : "none")};
  &:hover:not(:disabled) {
    border-color: rgba(201, 77, 170, 0.25);
    color: ${(p) => (p.$active ? "#fff" : "#c94daa")};
  }
  &:disabled {
    cursor: not-allowed;
    opacity: 0.45;
  }
`;

export const InventoryGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
  gap: 16px;
  padding: 4px 0 8px;
`;

export const GearCard = styled.article<{ $tone: string }>`
  position: relative;
  display: flex;
  flex-direction: column;
  gap: 14px;
  padding: 18px;
  border-radius: 18px;
  background: #fff;
  border: 1px solid rgba(23, 23, 23, 0.07);
  box-shadow: 0 8px 24px rgba(23, 23, 23, 0.04);
  overflow: hidden;
  transition: transform 0.18s ease, box-shadow 0.18s ease, border-color 0.18s ease;

  &::before {
    content: "";
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    width: 4px;
    background: ${(p) => p.$tone};
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 14px 32px rgba(23, 23, 23, 0.08);
    border-color: rgba(201, 77, 170, 0.18);
  }
`;

export const GearCardTop = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
`;

export const GearTitleBlock = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

export const GearTitle = styled.h3`
  margin: 0;
  font-family: Urbanist, sans-serif;
  font-size: 17px;
  font-weight: 800;
  color: #171717;
  line-height: 1.25;
`;

export const GearSubtitle = styled.p`
  margin: 0;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
`;

export const GearMetaLine = styled.div`
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin-top: 2px;
`;

export const SoftChip = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 600;
  color: rgba(23, 23, 23, 0.55);
  background: rgba(23, 23, 23, 0.04);
  border: 1px solid rgba(23, 23, 23, 0.06);
  padding: 3px 9px;
  border-radius: 8px;
`;

export const StockBlock = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 12px 14px;
  border-radius: 14px;
  background: linear-gradient(135deg, rgba(255, 201, 81, 0.06) 0%, rgba(206, 86, 176, 0.05) 100%);
  border: 1px solid rgba(201, 77, 170, 0.08);
`;

export const StockTrack = styled.div`
  height: 8px;
  border-radius: 999px;
  background: rgba(23, 23, 23, 0.06);
  overflow: hidden;
  display: flex;
`;

export const StockFill = styled.div<{ $pct: number; $tone: string }>`
  width: ${(p) => Math.max(0, Math.min(100, p.$pct))}%;
  height: 100%;
  background: ${(p) => p.$tone};
  border-radius: 999px;
  transition: width 0.3s ease;
`;

export const StockStats = styled.div`
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 8px;
`;

export const StockStat = styled.div`
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const StockStatLabel = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.04em;
  text-transform: uppercase;
  color: rgba(23, 23, 23, 0.42);
`;

export const StockStatValue = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 16px;
  font-weight: 800;
  color: #171717;
`;

export const AssignBlock = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 40px;
`;

export const AssignAvatar = styled.div`
  width: 34px;
  height: 34px;
  border-radius: 10px;
  display: grid;
  place-content: center;
  flex-shrink: 0;
  background: rgba(53, 183, 200, 0.12);
  color: #1a8a98;
  font-family: Urbanist, sans-serif;
  font-weight: 800;
  font-size: 13px;
`;

export const AssignText = styled.div`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: 2px;
`;

export const AssignPrimary = styled.span`
  font-family: Urbanist, sans-serif;
  font-size: 13px;
  font-weight: 700;
  color: #171717;
`;

export const AssignSecondary = styled.span`
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 500;
  color: rgba(23, 23, 23, 0.5);
`;

export const AlertDot = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  gap: 5px;
  font-family: Montserrat, sans-serif;
  font-size: 11px;
  font-weight: 700;
  color: ${(p) => p.$color};
`;

export const GearCardActions = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: auto;
  padding-top: 4px;
  border-top: 1px solid rgba(23, 23, 23, 0.06);
  padding-top: 14px;
`;

export const PrimaryActionBtn = styled.button<{ $variant?: "assign" | "return" }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 7px;
  height: 38px;
  padding: 0 14px;
  border-radius: 11px;
  border: none;
  cursor: pointer;
  font-family: Montserrat, sans-serif;
  font-size: 12px;
  font-weight: 700;
 color: #fff;
  background: ${(p) =>
    p.$variant === "return"
      ? "linear-gradient(135deg, #35b7c8 0%, #1a8a98 100%)"
      : gradient};
box-shadow: 0 6px 16px rgba(201, 77, 170, 0.22);
transition: transform 0.15s ease, opacity 0.15s ease;
  transition: all 0.15s ease;
  flex: 1;

  &:hover:not(:disabled) {
    
  transition: transform 0.15s ease, opacity 0.15s ease;
  }
  &:disabled {
    opacity: 0.4;
    cursor: not-allowed;
  }
`;

export const SecondaryActions = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`;

export const QuietIconBtn = styled.button<{ $danger?: boolean }>`
  width: 34px;
  height: 34px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
  border: 1px solid ${(p) => (p.$danger ? "rgba(228, 72, 98, 0.22)" : "rgba(201, 77, 170, 0.18)")};
  background: ${(p) => (p.$danger ? "rgba(228, 72, 98, 0.06)" : "rgba(201, 77, 170, 0.06)")};
  color: ${(p) => (p.$danger ? "#e44862" : "#c94daa")};
  cursor: pointer;
  flex: 0 0 auto;
  transition: all 0.15s ease;
  ${actionTooltipStyles}

  &:hover {
    background: ${(p) => (p.$danger ? "rgba(228, 72, 98, 0.12)" : "rgba(201, 77, 170, 0.12)")};
    transform: translateY(-1px);
  }
`;

export const SectionHead = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  margin-bottom: 4px;
`;

